import { useState } from "react";
import "./ReactChipInput.css";
import { CloseBorderlessIcon } from "../../utils/icons.jsx";

const ReactChipInput = ({
  chips = [],
  onSubmit,
  onRemove,
  classes = "",
  placeholder = "Type and press Enter...",
  validateEmail = true,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState("");

  const isValidEmail = (email) => {
    return email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
  };

  const handleKeyDown = (e) => {
    setError("");

    if (e.key === "Enter") {
      e.preventDefault();
      const value = inputValue.trim();

      if (!value) return;

      if (validateEmail && !isValidEmail(value)) {
        setError("Please enter a valid email");
        return;
      }

      if (chips.includes(value)) {
        setError("Already added");
        return;
      }

      onSubmit(value);
      setInputValue("");
    }

    if (e.key === "Backspace" && !inputValue && chips.length > 0) {
      e.preventDefault();
      onRemove(chips.length - 1);
    }
  };

  return (
    <div className={`react-chip-input-container ${classes}`}>
      <div className={`react-chip-input-wrapper ${error ? "has-error" : ""}`}>
        {/* Chip counter badge */}
        {chips.length > 0 && (
          <div className="react-chip-input-counter">{chips.length}</div>
        )}

        <div className="react-chip-input-chips-container">
          {chips.map((chip, index) => (
            <div key={index} className="react-chip-input-chip">
              <span title={chip}>{chip}</span>
              <div
                onClick={() => onRemove(index)}
                className="react-chip-input-chip-remove"
                aria-label={`Remove ${chip}`}
                title={`Remove ${chip}`}
              >
                <img alt="close" src={CloseBorderlessIcon} />
              </div>
            </div>
          ))}

          <input
            type={validateEmail ? "email" : "text"}
            className="react-chip-input-text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={chips.length === 0 ? placeholder : "Add more..."}
            aria-label="Add new item"
          />
        </div>
      </div>

      {error && (
        <div className="react-chip-input-error">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
          </svg>
          {error}
        </div>
      )}
    </div>
  );
};

export default ReactChipInput;
